import { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "primereact/button";

import { CardTemplate } from "./CardTemplate";
import { useIntroHighlightedContent } from "../../../../featureFlags";
import { useUserContext } from "sj-ui-toolkit/src/atlas/contexts/User/UserContextProvider";
import { useSegmentTrackEvent } from "sj-ui-toolkit/src/hooks";

export const HighlightedContent = ({ additionalItems = [] }) => {
  const [defaultItems, setDefaultItems] = useState([]);
  const { isTourVisible, toggleTourVisibility } = useUserContext();
  const flagCardValues = useIntroHighlightedContent();
  const trackEvent = useSegmentTrackEvent();
  const hasSentTourViewed = useRef(false);

  useEffect(() => {
    if (isTourVisible && flagCardValues?.defaultItems && defaultItems.length === 0) {
      setDefaultItems(addImageUrlToDefaultItems(flagCardValues.defaultItems));
    }
  }, [isTourVisible]);

  // LD provides the image filename, which we match to the corresponding image in our public/images folder
  const addImageUrlToDefaultItems = items => {
    return items.map(item => {
      if (item.image) {
        return { ...item, image: `images/${item.image}.png` };
      }
      return item;
    });
  };

  const highlightedCardData = useMemo(() => {
    return isTourVisible ? [...defaultItems, ...additionalItems] : [...additionalItems];
  }, [additionalItems, defaultItems, isTourVisible]);

  useEffect(() => {
    if (isTourVisible && highlightedCardData.length && !hasSentTourViewed.current) {
      trackEvent("Tour viewed", {});
      hasSentTourViewed.current = true;
    }
  }, [isTourVisible, highlightedCardData, trackEvent]);

  if (!highlightedCardData.length || !isTourVisible) {
    return null;
  }
  return (
    <div className="pb-5">
      <div className="flex justify-end pb-1">
        <Button
          label="Dismiss"
          icon="pi pi-times"
          severity="secondary"
          text={true}
          onClick={toggleTourVisibility}
        />
      </div>
      <div className="horizontalCardScrollContainer">
        {highlightedCardData.map((item, index) => (
          <CardTemplate {...item} key={item.id || index} />
        ))}
      </div>
    </div>
  );
};
